import * as youTubeDirective from './youtube.directive';

export default angular.module('gazelle.components.youTube', [
])
  .directive(youTubeDirective.name, youTubeDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/youtube/youtube.module.js